import React, { Component } from "react";
import axiosInstance from "../../api/utils/axiosInstance";
import {
  handleUserInput,
  handleMappedUserInput,
} from "../../helperFunctions/EntryFormHelperFunctions/userInputHandlers";
import {
  handleCountryAutocomplete,
  countryAutocompleteHandler,
  countyAutocompleteHandler,
  cityAndMuncipalityAutocomplete,
  districtAutocompleteHandler,
} from "../../helperFunctions/EntryFormHelperFunctions/autocompleteHelpers";
import {
  formSubmitError,
  formSubmitSuccess,
} from "../../store/actions/forms/formActions";
import { connect } from "react-redux";
import {
  validateRequiredFields,
  validateArrayFields,
} from "../../helperFunctions/validationHelpers/validateRequiredFields";

import { handleDayPicker } from "../../helperFunctions/EntryFormHelperFunctions/datePickerHelper";
import Spinner from "../../components/UI/Spinner/Spinner";
import fetchFormsApi from "../../api/formsApi/fetchFormsApi";
import { EntryForm8 } from "../../components/EntryForms/EntryForm8/EntryForm8";
import { purgeUpdateAndRedirect } from "../../helperFunctions/purgeUpdateAndRedirect";
import { PURGE_UPDATE } from "../../constants/constants";

class RegOvlRevizoraIzDrugihZemalja extends Component {
  state = {
    error: false,
    update: false,
    loader: false,
    requestsLoaded: false,
    countryList: [],
    countyList: [],
    cityAndMuncipalityList: [],
    districtList: [],
    newFormData: {
      oznDokumenta: {
        oznDokumenta: "",
      },
      cityAndMuncipalityList: [],
      districtList: [],
      selectedDropdownValue: "",
      dropDownData: [
        {
          id: 1,
          value: "Ovlašteni revizor",
        },
        { id: 2, value: "Dioničar/član društva" },
        { id: 3, value: "Direktor" },
        { id: 4, value: "Predsjednik uprave" },
        { id: 5, value: "Član uprave" },
        { id: 6, value: "Prokurist" },
        { id: 7, value: "Član upravnog odbora" },
      ],
      userData: {
        vrOsobe: "4",
        oznAkt: "",
        oib: "",
        ime: "",
        prezime: "",
        regBroj: "",
        idBroj: "",
        oibValidated: false,
        requiredFieldsUserData: ["ime", "prezime"],
        tstampUnosa: null,
      },
      address: {
        vrAdr: "1",
        sifDrzave: "191",
        sifZupanije: "",
        nazZupanije: "",
        sifGrdOpc: "",
        nazGrdOpc: "",
        sifNaselja: "",
        nazNaselja: "",
        brPoste: "",
        ulicaKbr: "",
        permitDate: "",
        permitNumber: "",
        requiredFieldsAddress: [
          "sifDrzave",
          "sifZupanije",
          "nazZupanije",
          "sifGrdOpc",
          "nazGrdOpc",
          "sifNaselja",
          "brPoste",
          "ulicaKbr",
          "permitDate",
          "permitNumber",
        ],
      },
      residencyAddress: {
        vrAdr: "2",
        sifDrzave: "191",
        sifZupanije: "",
        nazZupanije: "",
        sifGrdOpc: "",
        nazGrdOpc: "",
        sifNaselja: "",
        nazNaselja: "",
        brPoste: "",
        ulicaKbr: "",
        requiredFieldsResidencyAddress: [
          "sifDrzave",
          "sifZupanije",
          "nazZupanije",
          "sifGrdOpc",
          "nazGrdOpc",
          "sifNaselja",
          "brPoste",
          "ulicaKbr",
        ],
      },
      reviserRegistration: [
        {
          funkcija: "",
          vrVeze: "",
          idDrustva: "",
          oibIdBrojDrustva: "",
          id: 1,
          requiredFieldsReviserRegistration: ["vrVeze"],
          ime: "",
          prezime: "",
          nazDrustva: "",
          dataFetched: false,
          sifDrzave: "",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          web: "",
        },
      ],
      revRegWorkLicence: [
        {
          id: 1,
          vrRegistracije: "1",
          nazTijela: "",
          sifDrzave: "336",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          brReg: "",
          datReg: "",
          brRegOrig: "",
        },
      ],
      revReg3rdParty: [
        {
          id: 1,
          vrRegistracije: "2",
          nazTijela: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          brReg: "",
          datReg: "",
          // requiredFieldsRevReg3rdParty: ["ulicaKbr"],
        },
      ],
      revRegCompetentBody: [
        {
          id: 1,
          vrRegistracije: "3",
          nazTijela: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          // requiredFieldsRevRegCompetentBody: ["ulicaKbr"],
        },
      ],
      mjere: [],
    },
  };

  componentDidMount = () => {
    this.getCountryList();
  };

  getOsobaEdit = async (oznaka) => {
    const { idOsobe, vrOsobe } = this.props;

    const { data } = await axiosInstance.get(
      `/findOsoba?idOsobe=${idOsobe}&vrOsobe=${vrOsobe}&showHistory=false`
    );

    const addressRegistration = data[3][0];

    let findAddressPrebivaliste = data[2].find((element) => element.vrAdr == 1);

    if (!findAddressPrebivaliste) {
      findAddressPrebivaliste = data[2].find((element) => element.vrAdr == 2);
    }

    const address = {
      vrAdr: "1",
      sifDrzave: String(findAddressPrebivaliste.sifDrzave),
      sifZupanije: findAddressPrebivaliste.sifZupanije
        ? String(findAddressPrebivaliste.sifZupanije)
        : "",
      nazZupanije: findAddressPrebivaliste.nazZupanije || "",
      sifGrdOpc: findAddressPrebivaliste.sifGrdOpc
        ? String(findAddressPrebivaliste.sifGrdOpc)
        : "",
      nazGrdOpc: findAddressPrebivaliste.nazGrdOpc || "",
      sifNaselja: findAddressPrebivaliste.sifNaselja
        ? String(findAddressPrebivaliste.sifNaselja)
        : "",
      nazNaselja: findAddressPrebivaliste.nazNaselja || "",
      brPoste: findAddressPrebivaliste.brPoste || "",
      ulicaKbr: findAddressPrebivaliste.ulicaKbr || "",
      permitDate: addressRegistration.datReg || "",
      permitNumber: addressRegistration.brReg || "",
      requiredFieldsAddress: [
        "sifDrzave",
        "sifZupanije",
        "nazZupanije",
        "sifGrdOpc",
        "nazGrdOpc",
        "sifNaselja",
        "brPoste",
        "ulicaKbr",
        "permitDate",
        "permitNumber",
      ],
    };

    if (address.sifZupanije) {
      this.getCityAndMuncipalityList(address.sifZupanije);
    }

    if (address.sifGrdOpc) {
      this.getDistrictList(address.sifGrdOpc);
    }

    const findAddressBoraviste = data[2].find((element) => element.vrAdr == 2);

    const residencyAddress = {
      vrAdr: "2",
      sifDrzave: findAddressBoraviste.sifDrzave
        ? String(findAddressBoraviste.sifDrzave)
        : "",
      sifZupanije: findAddressBoraviste.sifZupanije
        ? String(findAddressBoraviste.sifZupanije)
        : "",
      nazZupanije: findAddressBoraviste.nazZupanije || "",
      sifGrdOpc: findAddressBoraviste.sifGrdOpc
        ? String(findAddressBoraviste.sifGrdOpc)
        : "",
      nazGrdOpc: findAddressBoraviste.nazGrdOpc || "",
      sifNaselja: findAddressBoraviste.sifNaselja
        ? String(findAddressBoraviste.sifNaselja)
        : "",
      nazNaselja: findAddressBoraviste.nazNaselja || "",
      brPoste: findAddressBoraviste.brPoste || "",
      ulicaKbr: findAddressBoraviste.ulicaKbr || "",
      requiredFieldsResidencyAddress: [
        "sifDrzave",
        "sifZupanije",
        "nazZupanije",
        "sifGrdOpc",
        "nazGrdOpc",
        "sifNaselja",
        "brPoste",
        "ulicaKbr",
      ],
    };

    if (residencyAddress.sifZupanije) {
      this.getCityAndMuncipalityList(residencyAddress.sifZupanije, true);
    }

    if (residencyAddress.sifGrdOpc) {
      this.getDistrictList(residencyAddress.sifGrdOpc, true);
    }

    const findRevRegWorkLicence = data[3].filter(
      (element, index) =>
        element.vrRegistracije == 1 && element.sifDrzave !== 191
    );

    let revRegWorkLicence;
    if (findRevRegWorkLicence.length > 0) {
      revRegWorkLicence = findRevRegWorkLicence.map((element, index) => {
        return {
          vrRegistracije: "1",
          id: index + 1,
          nazTijela: element.nazTijela || "",
          sifDrzave: String(element.sifDrzave) || "",
          nazNaselja: element.nazNaselja || "",
          brPoste: element.brPoste || "",
          brReg: element.brReg || "",
          datReg: element.datReg || "",
          ulicaKbr: element.ulicaKbr || "",
          brRegOrig: element.brRegOrig || "",
        };
      });
    } else {
      revRegWorkLicence = this.state.newFormData.revRegWorkLicence;
    }

    const findReg3rdParty = data[3].filter(
      (element) => element.vrRegistracije == 2
    );

    let revReg3rdParty;
    if (findReg3rdParty.length > 0) {
      revReg3rdParty = findReg3rdParty.map((element, index) => {
        return {
          vrRegistracije: "2",
          id: index + 1,
          nazTijela: element.nazTijela || "",
          sifDrzave: String(element.sifDrzave || ""),
          nazNaselja: element.nazNaselja || "",
          brPoste: element.brPoste || "",
          brReg: element.brReg || "",
          datReg: element.datReg || "",
          ulicaKbr: element.ulicaKbr || "",
          // requiredFieldsRevReg3rdParty: ["ulicaKbr"],
        };
      });
    } else {
      revReg3rdParty = this.state.newFormData.revReg3rdParty;
    }

    const findRevRegCompetentBody = data[3].filter(
      (element) => element.vrRegistracije == 3
    );

    let revRegCompetentBody;
    if (findRevRegCompetentBody.length > 0) {
      revRegCompetentBody = findRevRegCompetentBody.map((element, index) => {
        return {
          vrRegistracije: "3",
          id: index + 1,
          nazTijela: element.nazTijela || "",
          sifDrzave: String(element.sifDrzave || ""),
          nazNaselja: element.nazNaselja || "",
          brPoste: element.brPoste || "",
          brReg: element.brReg || "",
          datReg: element.datReg || "",
          ulicaKbr: element.ulicaKbr || "",
          // requiredFieldsRevRegCompetentBody: ["ulicaKbr"],
        };
      });
    } else {
      revRegCompetentBody = this.state.newFormData.revRegCompetentBody;
    }

    let reviserRegistration;
    let clanstvaIRevizorstva = [];

    if (data[4].length > 0) {
      data[4].forEach((element) => {
        clanstvaIRevizorstva.push(element);
      });
    }
    if (data[8].length > 0) {
      data[8].forEach((element) => {
        let temp = {
          ...element,
          oibIdBrojDrustva: element.idBroj ? element.idBroj : element.oib,
        };
        switch (element.funkcija) {
          case "Dioničar/član društva":
            temp = {
              ...temp,
              vrVeze: 2,
            };
            break;
          case "Direktor":
            temp = {
              ...temp,
              vrVeze: 3,
            };
            break;
          case "Predsjednik uprave":
            temp = {
              ...temp,
              vrVeze: 4,
            };
            break;
          case "Član uprave":
            temp = {
              ...temp,
              vrVeze: 5,
            };
            break;
          case "Prokurist":
            temp = {
              ...temp,
              vrVeze: 6,
            };
            break;
          case "Član upravnog odbora":
            temp = {
              ...temp,
              vrVeze: 7,
            };
            break;
          default:
            break;
        }
        clanstvaIRevizorstva.push(temp);
      });
    }
    if (clanstvaIRevizorstva.length > 0) {
      reviserRegistration = clanstvaIRevizorstva.map((element, index) => {
        return {
          vrVeze: element.vrDrustva,
          funkcija: element.vrVeze,
          idDrustva: element.idDrustva,
          oibIdBrojDrustva: element.oibIdBrojDrustva || "",
          id: index + 1,
          ime: element.imeDrustva || "",
          prezime: element.prezimeDrustva || "",
          nazDrustva: element.nazivDrustva || "",
          dataFetched: true,
          sifDrzave: element.idDrzaveDrustva,
          brPoste: element.postanskiBrojDrustva || "",
          nazNaselja: element.nazivNaseljaDrustva || "",
          ulicaKbr: element.ulicaKbrDrustva || "",
          web: element.web || "",
          requiredFieldsReviserRegistration: ["vrVeze"],
        };
      });
    } else {
      reviserRegistration = this.state.newFormData.reviserRegistration;
    }

    let oznDokumenta = {};

    if (oznaka) {
      oznDokumenta.oznDokumenta = oznaka;
    } else {
      oznDokumenta.oznDokumenta = data[5].oznDokumenta;
    }

    this.setState((prevState) => ({
      update: true,
      requestsLoaded: true,
      newFormData: {
        ...prevState.newFormData,
        oznDokumenta,
        userData: {
          ...prevState.newFormData.userData,
          oznAkt: data[1]?.oznAkt || "",
          oib: data[1]?.oib || "",
          ime: data[1]?.ime || "",
          prezime: data[1]?.prezime || "",
          regBroj: data[1]?.regBroj || "",
          idOsobe: data[1]?.idOsobe || "",
          idBroj: data[1]?.idBroj || "",
          oibValidated: true,
          tstampUnosa: data[1].tstampUnosa,
        },
        address,
        reviserRegistration,
        residencyAddress,
        revRegWorkLicence,
        revReg3rdParty,
        revRegCompetentBody,
        mjere: data[7],
      },
    }));
  };

  //get podataka za autocomplete komponentu

  getCountryList = async () => {
    const { data } = await axiosInstance.get("/sifarnici/drzave");
    this.setState(
      (prevState) => ({
        countryList: data,
      }),
      () => {
        this.getCountyList();
      }
    );
  };

  checkIfUpdate = (url) => {
    return this.props.match.url.includes(url);
  };

  getCountyList = async () => {
    const { data } = await axiosInstance.get("/sifarnici/zupanije");
    const updatePage = this.props.match.url.includes(
      "/azuriraj/registar-ovlastenih-revizora-iz-drugih-drzava-clanica"
    );

    this.setState(
      (prevState) => ({
        countyList: data,
      }),
      () => {
        if (
          this.checkIfUpdate(
            "/azuriraj/registar-ovlastenih-revizora-iz-trecih-zemalja"
          )
        ) {
          if (this.props.idOsobe != this.props.match.params.id) {
            const { purgeUpdate, history } = this.props;
            purgeUpdateAndRedirect(purgeUpdate, () =>
              history.push("/pregled-registara")
            );
            return;
          }

          this.getOsobaEdit();
        } else if (
          this.checkIfUpdate(
            "/azuriraj-po-zahtjevu/registar-ovlastenih-revizora-iz-trecih-zemalja"
          )
        ) {
          if (this.props.idOsobe != this.props.match.params.id) {
            const { purgeUpdate, history } = this.props;
            purgeUpdateAndRedirect(purgeUpdate, () =>
              history.push("/pregled-registara")
            );
            return;
          }
          const oznDokumenta = this.props.oznDokumenta;
          this.getOsobaEdit(oznDokumenta);
        } else {
          this.getDataFromUnosZahtjeva();
        }
      }
    );
  };

  getDataFromUnosZahtjeva = async () => {
    const { data } = await fetchFormsApi(
      `/request/${this.props.zahtjevAtrId}?isEdit=${false}`
    );

    const findObjectByLabelAndGroup = (label, group) => {
      const findLabel = data.groupList.map((el) =>
        el.controlList.find(
          (element) =>
            element.controlLabel == label && element.addressGroup === group
        )
      );
      return findLabel;
    };

    const findObjectByLabel = (label) => {
      const findLabel = data.groupList.map((el) =>
        el.controlList.find((element) => element.controlLabel == label)
      );
      return findLabel;
    };

    const findCroCountry = findObjectByLabelAndGroup("Naziv države", 1);

    const findCity = findObjectByLabelAndGroup("Naziv grada", 1);

    const findDistrict = findObjectByLabelAndGroup("Naziv mjesta", 1);

    const findbrPoste = findObjectByLabelAndGroup("Poštanski broj", 1);

    const findUlica = findObjectByLabelAndGroup("Ulica", 1);

    const findKucniBr = findObjectByLabelAndGroup("Kućni broj", 1);

    let ulicaKbr;

    if (findUlica[0].value || findKucniBr[0].value) {
      ulicaKbr = `${findUlica[0].value} ${findKucniBr[0].value}`;
    } else {
      ulicaKbr = "";
    }
    const brPoste = findbrPoste[0].value;

    let sifZupanije;
    let nazZupanije;
    let sifGrdOpc;
    let nazGrdOpc;
    let cityAndMuncipalityList;
    let districtList;
    let nazNaselja;
    let sifNaselja;
    let getDistrictList;

    if (findCroCountry[0].value == 191 && findCity[0].value != "") {
      const response = await axiosInstance.get(
        `/sifarnici/grad/${findCity[0].value}`
      );
      sifZupanije = response.data.sifZupanije.toString();
      nazZupanije = response.data.nazZupanije;
      sifGrdOpc = findCity[0].value;

      const getCityList = await axiosInstance.get(
        `/sifarnici/gradOpcina/${sifZupanije}`
      );
      cityAndMuncipalityList = getCityList.data;

      getDistrictList = await axiosInstance.get(
        `/sifarnici/naselja/${sifGrdOpc}`
      );
      districtList = getDistrictList.data;
      const findNazivGrada = getCityList.data.filter((element) =>
        element.gradoviOpcine.find((el) => el.sifGrdOpc == sifGrdOpc)
      );

      nazGrdOpc = findNazivGrada[0].gradoviOpcine[0].nazGrdOpc;

      sifNaselja = findDistrict[0].value;

      const findNazivNaselja = getDistrictList.data.filter((element) =>
        element.naselja.find((el) => el.sifNaselja == sifNaselja)
      );

      if (findNazivNaselja.length > 0) {
        nazNaselja = findNazivNaselja[0].naselja[0].nazNaselja;
      } else {
        nazNaselja = findDistrict[0].value;
        sifNaselja = "";
      }
    } else {
      nazZupanije = "";
      sifZupanije = "";
      nazGrdOpc = findCity[0].value;
      cityAndMuncipalityList = [];
      districtList = [];
      nazNaselja = findDistrict[0].value;
      sifGrdOpc = "";
      sifNaselja = "";
      districtList = [];
    }

    const address = {
      ...this.state.newFormData.address,
      sifDrzave: findCroCountry[0].value,
      sifZupanije,
      nazZupanije,
      sifGrdOpc,
      nazGrdOpc,
      brPoste,
      ulicaKbr,
      nazNaselja,
      sifNaselja,
    };

    //reMapiranje

    const findRegistrationCountry = findObjectByLabelAndGroup(
      "Naziv države",
      2
    );
    const findRegBrPoste = findObjectByLabelAndGroup("Poštanski broj", 2);
    const findRegUlicaKbr = findObjectByLabelAndGroup("Ulica i kućni broj", 2);
    const findRegDistrict = findObjectByLabelAndGroup("Naziv mjesta", 2);

    let regDistrict;

    if (
      findRegistrationCountry[0].value == 191 &&
      findRegDistrict[0].value != ""
    ) {
      const { data } = await axiosInstance.get(
        `/sifarnici/naselja/naziv/${findRegDistrict[0].value}`
      );
      regDistrict = data.nazNaselja;
    } else {
      regDistrict = findRegDistrict[0].value;
    }

    const brOdobrenjaMatDrzave = findObjectByLabel(
      "Broj odobrenja za rad izdanog od nadležnog tijela iz treće zemlje",
      0
    );
    const datumOdobrenjaMatDrzave = findObjectByLabel(
      "Datum odobrenja za rad izdanog od nadležnog tijela iz treće zemlje",
      0
    );
    const nazivTijelaMatDrzave = findObjectByLabel(
      "Naziv nadležnog tijela za izdavanje odobrenja za rad iz treće zemlje",
      0
    );

    const brRegMatDrzave = brOdobrenjaMatDrzave[0]
      ? brOdobrenjaMatDrzave[0].value
      : "";
    const datRegMatDrzave = datumOdobrenjaMatDrzave[0]
      ? datumOdobrenjaMatDrzave[0].value
      : "";
    const nazTijelaMatDrzave = nazivTijelaMatDrzave[0]
      ? nazivTijelaMatDrzave[0].value
      : "";

    const revRegWorkLicence = [
      {
        id: 1,
        vrRegistracije: "1",
        nazTijela: nazTijelaMatDrzave,
        brReg: brRegMatDrzave,
        datReg: datRegMatDrzave,
        sifDrzave: findRegistrationCountry[0]?.value || "336",
        nazNaselja: regDistrict,
        brPoste: findRegBrPoste[0]?.value || "",
        ulicaKbr: findRegUlicaKbr[0]?.value || "",
        brRegOrig: "",
      },
    ];

    const findBrRegDrugeDrzave = findObjectByLabel(
      "Broj registracije kod nadležnog tijela druge države članice"
    );

    const findNazivTijelaDrugeDrzave = findObjectByLabel(
      "Naziv nadležnog tijela iz druge države članice"
    );

    const findBrRegTreceZemlje = findObjectByLabel(
      "Broj registracije kod nadležnog tijela u trećoj zemlji"
    );

    const findNazivTijelaTreceZemlje = findObjectByLabel(
      "Naziv nadležnog tijela u trećoj zemlji"
    );

    const brRegDrDrzave = findBrRegDrugeDrzave[0]
      ? findBrRegDrugeDrzave[0].value
      : "";

    const nazTijelaDrDrzave = findNazivTijelaDrugeDrzave[0]
      ? findNazivTijelaDrugeDrzave[0].value
      : "";

    const brRegTreceZemlje = findBrRegTreceZemlje[0]
      ? findBrRegTreceZemlje[0].value
      : "";

    const nazTijelaTreceZemlje = findNazivTijelaTreceZemlje[0]
      ? findNazivTijelaTreceZemlje[0].value
      : "";

    const regDrugeDrzaveExists =
      brRegDrDrzave.length > 0 || nazTijelaDrDrzave.length > 0;

    const regTreceZemljeExists =
      brRegTreceZemlje.length > 0 || nazTijelaTreceZemlje.length > 0;

    const revReg3rdParty = [];

    if (regDrugeDrzaveExists) {
      const reviserDataDrDrzave = {
        vrRegistracije: "2",
        nazTijela: nazTijelaDrDrzave,
        sifDrzave: "191",
        nazNaselja: "",
        brPoste: "",
        ulicaKbr: "",
        brReg: brRegDrDrzave,
        datReg: "",
        id: 1,
      };
      revReg3rdParty.push(reviserDataDrDrzave);
    }

    if (regTreceZemljeExists) {
      const reviserDataTreceZemlje = {
        vrRegistracije: "2",
        nazTijela: nazTijelaTreceZemlje,
        sifDrzave: "191",
        nazNaselja: "",
        brPoste: "",
        ulicaKbr: "",
        brReg: brRegTreceZemlje,
        datReg: "",
        id: regDrugeDrzaveExists ? 2 : 1,
      };
      revReg3rdParty.push(reviserDataTreceZemlje);
    }

    if (!regDrugeDrzaveExists && !regTreceZemljeExists) {
      revReg3rdParty.push({
        vrRegistracije: "2",
        nazTijela: "",
        sifDrzave: "191",
        nazNaselja: "",
        brPoste: "",
        ulicaKbr: "",
        brReg: "",
        datReg: "",
        id: 1,
      });
    }

    this.setState(
      (prevState) => ({
        cityAndMuncipalityList,
        districtList,
        newFormData: {
          ...prevState.newFormData,
          userData: {
            ...prevState.newFormData.userData,
            oibValidated: true,
            oib: data.oib || "",
            ime: data.ime || "",
            prezime: data.prezime || "",
            idBroj: data.idBroj || "",
          },
          address,
          revReg3rdParty,
          revRegWorkLicence,
        },
      }),
      () => {
        this.disableLoader();
      }
    );
  };

  disableLoader = () => {
    this.setState({
      requestsLoaded: true,
    });
  };

  getCityAndMuncipalityList = async (countyId, secondaryAddress) => {
    const { data } = await axiosInstance.get(
      `/sifarnici/gradOpcina/${countyId}`
    );

    if (secondaryAddress) {
      this.setState((prevState) => ({
        newFormData: {
          ...prevState.newFormData,
          cityAndMuncipalityList: data,
        },
      }));
      return;
    }

    this.setState({
      cityAndMuncipalityList: data,
    });
  };

  getDistrictList = async (id, secondaryAddress) => {
    const { data } = await axiosInstance.get(`/sifarnici/naselja/${id}`);

    if (secondaryAddress) {
      this.setState((prevState) => ({
        newFormData: {
          ...prevState.newFormData,
          districtList: data,
        },
      }));
      return;
    }

    this.setState((prevState) => ({
      districtList: data,
    }));
  };

  //userInputHandleri

  userInputHandler = (e, objectData) => {
    e.persist();
    // const id = e.target.id.replace(/[0-9]/g, "");
    const { name } = e.target;

    this.setState(handleUserInput(e, objectData), () => {
      name === "oib" &&
        this.state.newFormData.userData.oibValidated &&
        this.fetchUserDataCoib();
    });
  };

  fetchUserDataCoib = async () => {
    const oib = this.state.newFormData.userData.oib;
    const { data } = await axiosInstance.get(`/sifarnici/oib-data/${oib}`);

    const sifGradOpcina = data.sifraGradaOpcine.replace(/^0+/, "");
    const sifraNaselja = data.sifraNaselja.replace(/^0+/, "");

    this.getCityAndMuncipalityList(data.sifraZupanije);
    this.getDistrictList(sifGradOpcina);

    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        userData: {
          ...prevState.newFormData.userData,
          ime: data.ime,
          prezime: data.prezime,
        },
        address: {
          ...prevState.newFormData.address,
          sifDrzave: data.sifraDrzave,
          sifZupanije: data.sifraZupanije,
          nazZupanije: data.nazivZupanije,
          sifGrdOpc: sifGradOpcina,
          nazGrdOpc: data.grad,
          sifNaselja: sifraNaselja,
          nazNaselja: data.naselje,
          brPoste: data.postanskiBroj,
          ulicaKbr: `${data.adresa} ${data.kucniBroj} ${data.kucniBrojDodatak}`,
        },
      },
    }));
  };

  mappedUserInputHandler = (e, objectData) => {
    e.persist();
    this.setState(handleMappedUserInput(e, objectData), () => {
      if (
        objectData.group === "reviserRegistration" &&
        e.target.name === "oibIdBrojDrustva"
      ) {
        this.setState((prevState) => ({
          newFormData: {
            ...prevState.newFormData,
            [objectData.group]: [
              ...prevState.newFormData[objectData.group].map((element) =>
                element.id === objectData.id
                  ? {
                      //testirati
                      ...element,
                      sifDrzave: "",
                      nazNaselja: "",
                      brPoste: "",
                      ulicaKbr: "",
                      web: "",
                      dataFetched: false,
                      id: element.id,
                      idDrustva: "",
                      nazDrustva: "",
                    }
                  : element
              ),
            ],
          },
        }));
      }
    });
  };

  //autocomplete handleri

  setCountryAutocompleteHandler = (values, objectData) => {
    this.setState(handleCountryAutocomplete(values, objectData));
  };

  autocompleteCountryHandler = (values, objectData) => {
    this.setState(countryAutocompleteHandler(values, objectData));
  };

  autocompleteCountyHandler = (values, objectData, secondaryAddress) => {
    this.setState(
      countyAutocompleteHandler(
        values,
        objectData,
        this.getCityAndMuncipalityList,
        secondaryAddress
      )
    );
  };

  autocompleteCityHandler = (values, objectData, secondaryAddress) => {
    this.setState(
      cityAndMuncipalityAutocomplete(
        values,
        objectData,
        this.getDistrictList,
        secondaryAddress
      )
    );
  };

  autocompleteDistrictHandler = (values, objectData) => {
    const stateCopy = this.state;

    this.setState(districtAutocompleteHandler(values, objectData), () => {
      if (
        stateCopy.newFormData[objectData.formGroup].hasOwnProperty("brPoste") &&
        values != null
      ) {
        this.setState((prevState) => ({
          newFormData: {
            ...prevState.newFormData,
            [objectData.formGroup]: {
              ...prevState.newFormData[objectData.formGroup],
              brPoste: String(values.brPoste),
            },
          },
        }));
      }
    });
  };

  handleDayClick = (date, dateString, objData) => {
    this.setState(handleDayPicker(dateString, objData));
  };

  dropdownHandler = (e) => {
    e.persist();

    const id = e.target.id.replace(/[^0-9]/g, "");
    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        reviserRegistration: [
          ...prevState.newFormData.reviserRegistration.map((element) => {
            return id == element.id
              ? {
                  ...element,
                  funkcija: Number(e.target.value),
                }
              : element;
          }),
        ],
      },
    }));
  };

  //dohvat userovih podataka preko vrste i oib-a

  getUserData = async (e) => {
    e.preventDefault();
    e.persist();

    const id = e.currentTarget.id.replace(/[^0-9]/g, "");

    const newState = { ...this.state };
    const findUserObject = newState.newFormData.reviserRegistration.find(
      (element) => {
        return element.id == id;
      }
    );

    const selectedValue = findUserObject.vrVeze;

    let identifikacija = findUserObject.oibIdBrojDrustva;

    try {
      const res = await axiosInstance.get(
        `/sifarnici/drustva?vrDrustva=${selectedValue}&identifikacija=${identifikacija}`
      );
      const { data } = res;

      if (data.length === 0) {
        return this.props.formSubmitError(true, "Nema dostupnih podataka");
      }

      let userData = {
        funkcija: "",
        vrVeze: data[0].vrDrustva,
        sifDrzave: data[0].sifDrzave.toString(),
        nazNaselja: data[0].nazNaselja || "",
        brPoste: data[0].brPoste || "",
        ulicaKbr: data[0].ulicaKbr || "",
        web: data[0].web || "",
        dataFetched: true,
        id: findUserObject.id,
        idDrustva: data[0].idDrustva.toString(),
        oibIdBrojDrustva: data[0].oib || data[0].idBroj,
        requiredFieldsReviserRegistration:
          findUserObject.requiredFieldsReviserRegistration,
      };

      // requiredFieldsReviserRegistration: ["vrVeze"],

      switch (userData.vrVeze) {
        case "2":
          userData.ime = data[0].ime;
          userData.prezime = data[0].prezime;
          break;
        default:
          userData.nazDrustva = data[0].nazDrustva;
          break;
      }

      this.setState((prevState) => ({
        newFormData: {
          ...prevState.newFormData,
          reviserRegistration: [
            ...prevState.newFormData.reviserRegistration.map((element) => {
              return element.id == id ? userData : element;
            }),
          ],
        },
      }));
    } catch (e) {
      throw e;
    }
  };

  //višestruki unos

  multiplyComponent = (e, objData) => {
    e.persist();
    const lastElem = [...this.state.newFormData[objData.formGroup]];
    const addNewElement =
      (objData.formGroup === "revRegWorkLicence" && {
        id: lastElem[lastElem.length - 1].id + 1,
        vrRegistracije: "1",
        nazTijela: "",
        sifDrzave: "336",
        nazNaselja: "",
        brPoste: "",
        ulicaKbr: "",
        brReg: "",
        datReg: "",
        brRegOrig: "",
      }) ||
      (objData.formGroup === "revReg3rdParty" && {
        id: lastElem[lastElem.length - 1].id + 1,
        vrRegistracije: "2",
        nazTijela: "",
        sifDrzave: "191",
        nazNaselja: "",
        brPoste: "",
        ulicaKbr: "",
        brReg: "",
        datReg: "",
        // requiredFieldsRevReg3rdParty: ["ulicaKbr"],
      }) ||
      (objData.formGroup === "revRegCompetentBody" && {
        id: lastElem[lastElem.length - 1].id + 1,
        vrRegistracije: "3",
        nazTijela: "",
        sifDrzave: "191",
        nazNaselja: "",
        brPoste: "",
        ulicaKbr: "",
        // requiredFieldsRevRegCompetentBody: ["ulicaKbr"],
      }) ||
      (objData.formGroup === "reviserRegistration" && {
        funkcija:"",
        vrVeze: "",
        idDrustva: "",
        oibIdBrojDrustva: "",
        id: lastElem[lastElem.length - 1].id + 1,
        oibValidated: false,
        requiredFieldsReviserRegistration: ["vrVeze"],
        ime: "",
        prezime: "",
        nazDrustva: "",
        dataFetched: false,
        sifDrzave: "",
        nazNaselja: "",
        brPoste: "",
        ulicaKbr: "",
        web: "",
      });
    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        [objData.formGroup]: [
          ...prevState.newFormData[objData.formGroup],
          addNewElement,
        ],
      },
    }));
  };

  removeComponentHandler = (e, objectData) => {
    e.persist();
    const lastElem = [...this.state.newFormData[objectData.formGroup]];
    const { formGroup } = objectData;
    const arrayLength = this.state.newFormData[formGroup].length;
    const id = e.currentTarget.id.replace(/[^0-9]/g, "");
    if (arrayLength > 1) {
      this.setState((prevState) => ({
        newFormData: {
          ...prevState.newFormData,
          [formGroup]: [
            ...prevState.newFormData[formGroup].filter(
              (element) => element.id != id
            ),
          ],
        },
      }));
    } else {
      alert("Uklanjanje nije moguće!");
    }
  };

  submitHandler = async (e) => {
    const { zahtjevAtrId } = this.props;

    const stateCopy = { ...this.state.newFormData };
    const { requiredFieldsUserData } = stateCopy.userData;
    const validateUserData = validateRequiredFields(
      stateCopy.userData,
      requiredFieldsUserData
    );

    let { requiredFieldsAddress } = stateCopy.address;
    if (stateCopy.address.sifDrzave != "191") {
      requiredFieldsAddress = [
        "sifDrzave",
        "nazNaselja",
        "ulicaKbr",
        "permitDate",
        "permitNumber",
        "brPoste",
      ];
    }
    const validateAddress = validateRequiredFields(
      stateCopy.address,
      requiredFieldsAddress
    );

    let { requiredFieldsResidencyAddress } = stateCopy.residencyAddress;

    if (stateCopy.residencyAddress.sifDrzave != "191") {
      requiredFieldsResidencyAddress = [
        "sifDrzave",
        "nazNaselja",
        "ulicaKbr",
        "brPoste",
      ];
    }

    const validateResidencyAddress = validateRequiredFields(
      stateCopy.residencyAddress,
      requiredFieldsResidencyAddress
    );

    const validateReviserRegistration = stateCopy.reviserRegistration.every(
      (element) => element.funkcija !== ""
    );

    if (
      !validateUserData ||
      !validateReviserRegistration ||
      (!validateAddress && !validateResidencyAddress)
    ) {
      this.setState(
        {
          error: true,
        },
        () => {
          this.props.formSubmitError(true, "Popunite obavezna polja!");
        }
      );
      return;
    }

    if (
      stateCopy.userData.oib.length < 1 &&
      stateCopy.userData.idBroj.length < 1
    ) {
      this.setState(
        {
          error: true,
        },
        () => {
          this.props.formSubmitError(true, "Unesite OIB ili identifikator!");
        }
      );
      return;
    }

    if (!stateCopy.userData.oibValidated && stateCopy.userData.oib.length > 0) {
      this.props.formSubmitError(true, "OIB koji ste unijeli nije ispravan!");
      return;
    }

    const checkIfOibIsValid = [...stateCopy.reviserRegistration].filter(
      (element) => element.oibIdBrojDrustva.length < 1
    );

    if (checkIfOibIsValid.length > 0) {
      this.props.formSubmitError(
        true,
        "Unesite OIB ili identifikator! (Podaci o revizorskom društvu ili samostalnom revizoru)"
      );
      return;
    }

    const checkIfDataIsFetched = [...stateCopy.reviserRegistration].every(
      (element) => element.idDrustva
    );

    if (!checkIfDataIsFetched) {
      this.props.formSubmitError(
        true,
        "Dohvatite podatke o revizorskom društvu/samostalnom revizoru!"
      );
      return;
    }

    let userData = { ...stateCopy.userData };
    delete userData.requiredFieldsUserData;
    delete userData.oibValidated;
    delete userData.oznAkt;

    let address = { ...stateCopy.address };

    const userRegistration = {
      vrRegistracije: "1",
      // sifDrzave: address.sifDrzave,
      sifDrzave: "191",
      brReg: address.permitNumber,
      datReg: address.permitDate,
    };

    const residencyAddress = { ...stateCopy.residencyAddress };
    delete residencyAddress.requiredFieldsResidencyAddress;
    delete address.requiredFieldsAddress;
    delete address.permitDate;
    delete address.permitNumber;

    const mapRegistrationElements = (element) => {
      return {
        vrRegistracije: element.vrRegistracije,
        nazTijela: element.nazTijela,
        sifDrzave: element.sifDrzave,
        nazNaselja: element.nazNaselja,
        brPoste: element.brPoste,
        ulicaKbr: element.ulicaKbr,
        brReg: element.brReg,
        datReg: element.datReg,
      };
    };

    const revRegWorkLicence = [...this.state.newFormData.revRegWorkLicence].map(
      (element) => {
        return {
          vrRegistracije: element.vrRegistracije,
          nazTijela: element.nazTijela,
          sifDrzave: element.sifDrzave,
          nazNaselja: element.nazNaselja,
          brPoste: element.brPoste,
          ulicaKbr: element.ulicaKbr,
          brReg: element.brReg,
          datReg: element.datReg,
          brRegOrig: element.brRegOrig,
        };
      }
    );

    const revReg3rdParty = [...this.state.newFormData.revReg3rdParty].map(
      mapRegistrationElements
    );

    const revRegCompetentBody = [
      ...this.state.newFormData.revRegCompetentBody,
    ].map((element) => {
      return {
        vrRegistracije: element.vrRegistracije,
        nazTijela: element.nazTijela,
        sifDrzave: element.sifDrzave,
        nazNaselja: element.nazNaselja,
        brPoste: element.brPoste,
        ulicaKbr: element.ulicaKbr,
      };
    });

    const clanstva = [...this.state.newFormData.reviserRegistration].filter(
      (element) => element.funkcija !== 1 && element.funkcija
    );

    const revizorstva = [...this.state.newFormData.reviserRegistration].filter(
      (element) => element.funkcija === 1 && element.funkcija
    );

    const reviserRegistration = revizorstva.map((element) => {
      return {
        vrVeze: "1",
        idDrustva: element.idDrustva,
      };
    });

    const reviserMembership = clanstva.map((element) => {
      if (element.idDrustva) {
        let _clanDrustvo = {
          idDrustva: element.idDrustva,
          ime: userData.ime,
          prezime: userData.prezime,
          oib: userData.oib ? userData.oib : userData.idBroj,
          //dodati sta jos treba
          nazNaselja: element.nazNaselja,
          brPoste: element.brPoste,
          ulicaKbr: element.ulicaKbr,
          sifDrzave: element.sifDrzave,
        };
        switch (element.funkcija) {
          case 2:
            return {
              ..._clanDrustvo,
              vrClana: 1,
              funkcija: "Dioničar/član društva",
            };
          case 3:
            return {
              ..._clanDrustvo,
              vrClana: 2,
              funkcija: "Direktor",
            };
          case 4:
            return {
              ..._clanDrustvo,
              vrClana: 2,
              funkcija: "Predsjednik uprave",
            };
          case 5:
            return {
              ..._clanDrustvo,
              vrClana: 2,
              funkcija: "Član uprave",
            };
          case 6:
            return {
              ..._clanDrustvo,
              vrClana: 2,
              funkcija: "Prokurist",
            };
          case 7:
            return {
              ..._clanDrustvo,
              vrClana: 2,
              funkcija: "Član upravnog odbora",
            };
          default:
            return {
              idDrustva: "",
              vrClana: "",
            };
        }
      }
    });

    const { oznDokumenta } = this.state.newFormData;

    let submitAddresses = [];

    submitAddresses.push(address, residencyAddress);

    let submitRegistrations = [];

    submitRegistrations.push(
      userRegistration,
      ...revRegWorkLicence,
      ...revReg3rdParty,
      ...revRegCompetentBody
    );
    const submitData = [
      8,
      userData,
      submitAddresses,
      submitRegistrations,
      reviserRegistration,
      oznDokumenta,
      reviserMembership,
      [{}],
    ];

    try {
      this.setState({
        loader: true,
      });
      if (!this.state.update) {
        submitData.push([]);
        const res = await axiosInstance
          .post(`/unos/${zahtjevAtrId}`, submitData)
          .then(() =>
            this.setState({
              loader: false,
            })
          );
        this.props.formSubmitSuccess(
          false,
          "Podaci o subjektu uspješno upisani."
        );
        this.props.history.push("/odobrenje-zahtjeva");
        return;
      }
      submitData.push(stateCopy.mjere);
      const res = await axiosInstance.patch("/edit", submitData).then(() =>
        this.setState({
          loader: false,
        })
      );
      this.props.formSubmitSuccess(false, "Podaci uspješno ažurirani.");
      this.props.history.push("/pregled-registara");
    } catch (e) {
      this.props.formSubmitError(
        true,
        e.response.data.message ||
          "Nešto je pošlo po krivu, provjerite unesene podatke!"
      );
      this.setState({
        loader: false,
      });
    }
  };

  render() {
    const otherProps = {
      parentState: this.state,
      autocompleteCountryHandler: this.autocompleteCountryHandler,
      autocompleteCountyHandler: this.autocompleteCountyHandler,
      autocompleteCityHandler: this.autocompleteCityHandler,
      autocompleteDistrictHandler: this.autocompleteDistrictHandler,
      setCountryAutocompleteHandler: this.setCountryAutocompleteHandler,
      dropdownHandler: this.dropdownHandler,
      getUserData: this.getUserData,
      handleDayClick: this.handleDayClick,
      userInputHandler: this.userInputHandler,
      mappedUserInputHandler: this.mappedUserInputHandler,
      multiplyComponent: this.multiplyComponent,
      submitHandler: this.submitHandler,
      removeComponentHandler: this.removeComponentHandler,
    };

    return (
      <>
        {this.state.requestsLoaded ? (
          <EntryForm8 {...otherProps} />
        ) : (
          <Spinner />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    zahtjevAtrId: state.formData.zahtjevAtrId,
    idOsobe: state.update.idOsobe,
    vrOsobe: state.update.vrOsobe,
    oznDokumenta: state.update.oznDokumenta,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    formSubmitError: (error, notificationMessage) =>
      dispatch(formSubmitError(error, notificationMessage)),
    formSubmitSuccess: (error, notificationMessage) =>
      dispatch(formSubmitSuccess(error, notificationMessage)),
    purgeUpdate: () => dispatch({ type: PURGE_UPDATE }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegOvlRevizoraIzDrugihZemalja);
